import { ReactElement } from 'react';
import { getSchema } from '@localstack/services';
import { LambdaInvokeCommandOutput } from '@localstack/types';
import { ListItem, ListItemText } from '@mui/material';

import { MagicDetails } from '../../../magic/MagicDetails';
import { CodeSnippetViewer } from '../../../../display/CodeSnippetViewer';

export type LambdaInvocationDetailsProps = {
  details: Optional<Partial<LambdaInvokeCommandOutput>>;
};

const decodeUint8ArrayLike = (input: Uint8Array): string => new TextDecoder().decode(input);

export const LambdaInvocationDetails = ({ details }: LambdaInvocationDetailsProps): ReactElement => (
  <MagicDetails
    data={details}
    schema={getSchema('Lambda')}
    entry="InvocationResponse"
    title=""
    externalFields={{
      '^ExecutedVersion$': () => <></>,
      '^LogResult$': (data: string, fieldName: string) => (
        <ListItem>
          <ListItemText>
            <CodeSnippetViewer data={data} fieldName={fieldName} disableParsing />
          </ListItemText>
        </ListItem>
      ),
      '^FunctionError$': (data: string, fieldName: string) =>
        data ? (
          <ListItem>
            <ListItemText primary={fieldName} secondary={data} />
          </ListItem>
        ) : (
          <></>
        ),
      '^Payload$': (data: LambdaInvokeCommandOutput['Payload'], fieldName: string) => (
        <ListItem>
          <ListItemText>
            {data && <CodeSnippetViewer data={decodeUint8ArrayLike(data)} fieldName={fieldName} />}
          </ListItemText>
        </ListItem>
      ),
    }}
  />
);
